/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
// import { useLocation, useNavigate } from "react-router-dom";
import { ReactElement, RefObject, useEffect, useRef, useState } from 'react'
import { GoBackIcon } from '../../../assets/icons/BackIcon';
import { CalendarIcon, CaretDownIcon } from '../icon'
import { BusinessProps, EmployeesProp, HistoryProps, ChartDataProps } from '../../../includes/types';
import { Bar } from 'react-chartjs-2';
import { LightYellowButton } from '../../../components/buttons';
import './../style.css';
import { CONSTANTS } from '../../../includes/constant';
import { TabProps as TabPropsItem } from './business';
import { BaseLoader } from '../../../components/baseloader';
import { GetRequest, PostRequest } from '../../../includes/functions';
import moment from 'moment';
import { DownloadCSV } from '../../../includes/createCSVFileHook';
import { toast } from 'react-toastify';
import { Pagination } from '../../../components/pagination';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import EditIcon from '../../../assets/icons/editIcon';
import { TrashIcon } from '../icon';
import { ChartBoard } from '../components/chartSection';
import { ConfirmDialogComponent } from '../components/confirmDialog';
import { EditUserComponent } from '../components/editUser';
import { Menu } from './HistoryTables/invitations';
import ThreeVerticalDotsIcon from '../../../assets/icons/threeDots';
import { ImportPersonnelComponent } from '../components/importPersonnel';
import { AddEmployeeComponent } from '../components/addEmployee';
import { EmployeeBar } from '../components/employeeBar';
import { HistorySearchBar } from '../components/HistorySearchBar';
import { CalendarComponent } from '../../../components/Calender';
import { SearchBar } from '../components/searchBar';
import { TabProps } from './dashboard';
import { emitEvent, subscribeEvent } from '../../../includes/customEventHook';



export interface TabProp {
  class: string;
  title: string;
  amount: number;
}
interface BusinessDetailsProp {
  id?:string;
}
const BusinessDetails: React.FC<BusinessDetailsProp> = ({id}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [tab, setTab] = useState<TabPropsItem>('Business Information');
  const [businessDetails, setBusinessDetails] = useState<BusinessProps | null>(null);
  const [fetching, setFetching] = useState(false);
  const [numberOfActive, setNumberOfActive] = useState<number>(0);
  const searchParams = new URLSearchParams(location.search);
  const businessId = searchParams.get('id') || '';
  const fetchBusinessDetails = async (id:string) => {
    setFetching(true);
    GetRequest(`business/${id}`, {}).then((response)=>{
      if (response.status) {
        setBusinessDetails(response.data.business);
      } else{
     navigate(CONSTANTS.Routes.Businesses) 
  }})
 }
 useEffect(()=>{
  if(id)
  {
    fetchBusinessDetails(id);
  }
 },[id])
 useEffect(()=>{

 },[])
  return (
    <div className="main-scrollable p-5 pt-0">
      <div className="pb-3 d-flex align-items-center">
        <LightYellowButton
          to={`/${CONSTANTS.Routes.Dashboard}/${CONSTANTS.Routes.Businesses}`}
        >
          <GoBackIcon color="#F8B02B" size={15} />
          <span className="ps-2">Go back</span>
        </LightYellowButton>
        <div className="ps-5 mt-3 fw-bold">
          Businesses details ({businessDetails?.name})
        </div>
      </div>

      <nav className="d-flex align-items-center justify-content-start mt-4 tabContainer">
        {[
          'Business Information',
          'Employee Data',
          'Treepz History',
          // 'Attached vehicles',
        ].map((tabName) => (
          <div
            key={tabName}
            onClick={() => setTab(tabName as TabPropsItem)}
            className={'tab'}
          >
            <span 
            className={tab === tabName ? 'tab-active' : ''}
            >{tabName}</span>
          </div>
        ))}
      </nav>

      <div className='mt-3'>
        {tab === 'Business Information' && <BusinessInformation  
        
        />}
        {tab === 'Employee Data' && <EmployeeData 
        employees={businessDetails?.employees!}
        businessDetails={businessDetails!}
        />}
        {tab === 'Treepz History' && <BusinessTreepz 
        id={businessDetails?._id!}
        employees={businessDetails?.employees!}
        />
        }
        {/* {tab === 'Attached vehicles' && (
          <div>
            <h3>s</h3>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default BusinessDetails;
interface AdminProps {
  firstName?:string;
  lastName?:string;
  email?:string;
  phoneNumber?:string;
  role?:string;
}
const BusinessInformation: React.FC = () => {
  const [searchParams,setSearchParams] = useSearchParams()
  const [businessDetails, setBusinessDetails] = useState<BusinessProps | null>(
    null
  );
  const [fetching, setFetching] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const fetchBusinessDetails = async (id:string) => {
    setFetching(true);
GetRequest(`business/${id}`, {}).then((response)=>{
      if (response.status) {
        setBusinessDetails(response.data.business);
      } else{
     navigate(CONSTANTS.Routes.Businesses) 
  }})
 }
  useEffect(() => {
    const id = searchParams.get("id");
    if (id) {
      fetchBusinessDetails(id);
    }else{
    navigate(CONSTANTS.Routes.Businesses)
    }
    subscribeEvent(CONSTANTS.Events.businessDetails,()=>{})
  }, [searchParams]);


  const [adminDetails,setAdminDetails] = useState<AdminProps>();

  return (
    <div className='mt-4'>
      <div className="light-gray-business">
        <div className="row gap-4 align-items-center p-9">
          <div className='col-1'>
            <center>
              <div className="avatar d-flex align-items-center justify-content-center position-relative">
              {businessDetails?.image ? (
                <img src={businessDetails?.image} alt="Uploaded Logo" className="uploaded-logo" />
              ) : (
                <span className="fs-2 fw-bold orange-text">
                  {String(businessDetails?.name).split("").filter((a,i)=>i === 0).join("")}
                </span>
              )}
              </div>
            </center>
          </div>
          <div className='col-10 d-flex'>
            <div className='col-3'>
              <p style={{ color: '#6F7174' }}>Business name</p>
              <small style={{ color: '#4D5154', fontWeight: 'bold' }}>{businessDetails?.name || 'N/A'}</small>
            </div>
            <div className='col-3'>
              <p style={{ color: '#6F7174' }}>Physical address</p>
              <small style={{ color: '#4D5154', fontWeight: 'bold' }}>{businessDetails?.city?(businessDetails?.city+ ", "+businessDetails?.country):'N/A'}</small>
            </div>
            <div className='col-3'>
              <p style={{ color: '#6F7174' }}>Email address</p>
              <small style={{ color: '#4D5154', fontWeight: 'bold' }}>{businessDetails?.email || 'N/A'}</small>
            </div>
            <div className='col-3'>
              <p style={{ color: '#6F7174' }}>Staff strength</p>
              <small style={{ color: '#4D5154', fontWeight: 'bold' }}>{businessDetails?.employees?.length}</small>
            </div>
          </div>
        </div>
      </div>
      <div className='p-8'>
        <h5 style={{ color: '#4D5154', fontWeight: 'bold' }}>Administrator's details</h5>
        <div className="row mt-9">
         
            <div className="row mt-4">
              <div className="col">
                <p style={{ color: '#6F7174' }}>Full name</p>
                <small style={{ color: '#4D5154', fontWeight: 'bold' }}>{businessDetails?.adminFirstName} {businessDetails?.adminLastName}</small>
              </div>
              <div className="col">
                <p style={{ color: '#6F7174' }}>Role in organization</p>
                <small style={{ color: '#4D5154', fontWeight: 'bold' }}>Administrator</small>
              </div>
              <div className="col">
                <p style={{ color: '#6F7174' }}>Phone number</p>
                <small style={{ color: '#4D5154', fontWeight: 'bold' }}>{businessDetails?.adminPhoneNumber}</small>
              </div>
              <div className="col">
                <p style={{ color: '#6F7174' }}>Email address</p>
                <small style={{ color: '#4D5154', fontWeight: 'bold' }}>{businessDetails?.email}</small>
              </div>
            </div>
          
        </div>
      </div>
    </div>
  );
};

const EmployeeData = (props:{employees:EmployeesProp[],businessDetails:BusinessProps}) => {
  const [showAddPersonnel, setShowAddPersonnel] = useState<boolean>(false);
  const [fetching, setFetching] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [updating, setUpdating] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string>(moment().subtract(3, "M").toISOString());
  const [endDate, setEndDate] = useState<string>(moment().toISOString());
  const [pageSize, setPageSize] = useState<number>(50);
  const [numberOfPending, setNumberOfPending] = useState<number>(0);
  const [showEditUser, setShowEditUser] = useState<boolean>(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false);
  const [filterString, setFilterString] = useState<string>('');
  const [listOfBusiness, setListOfBusiness] = useState<BusinessProps[]>([]);
  const [pendingInvites, setPendingInvites] = useState<EmployeesProp[]>([]);
  const [activeEmployees, setActiveEmployees] = useState<EmployeesProp[]>([]);
  const [tab, setTab] = useState<string>('employee');
  const [numberOfActive, setNumberOfActive] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [loadingItem, setLoadingItem] = useState<string>('');
  const [selectedEmployee, setSelectedEmployee] = useState<BusinessProps | null>(null);
  const [showImportPersonnel, setShowImportPersonnel] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');
  const [processing, setProcessing] = useState<boolean>(false);

  const handleExport = () => {
    const list = listOfBusiness.map((a,i)=>{
      return {
        name:a.name,
        email:a.email,
        status:a.status,
        date:a.createdAt
      }
    });
    DownloadCSV({ data: list, fileName: 'BusinessEmployee_list' });
   
  };

  const DeleteUser = (id: any) => {
    setLoading(true);
    PostRequest(`delete:employee/${id}`, { }, true)
      .then((response) => {
        setLoading(false);
        if (response.status) {
          setShowConfirmDialog(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error('Error deleting user:', error);
      });
  };

  const CancelInvitation = (v: BusinessProps) => {
    setLoadingItem(String(v._id));
    PostRequest(`put:business/invite/cancel/${v._id}`, {}, true)
      .then((response) => {
        setLoadingItem('');
        if (response.status) {
          setShowConfirmDialog(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error('Error cancelling invitation', error);
      });
  };

  const ResendInvitation = (v: BusinessProps) => {
    setLoadingItem(String(v._id));
    PostRequest(
      `put:business/invite/resend`,
      {
        companyEmail: v.email,
      },
      true
    ).then((res) => {
      setLoadingItem('');
    });
  };
useEffect(()=>{
if(props.employees)
{
setActiveEmployees(props.employees);
// setPendingInvites(props.employees);
}
},[props.employees])
  useEffect(() => {
    
  }, [ currentPage]);

  const PendingInvitesTab = () => {
    return (
      <div className="">
        <table className='table table-responsive'>
          <thead>
            <tr>
              <th scope="col">S.No.</th>
              <th scope="col">Employee ID</th>
              <th scope="col">Employee Name</th>
              <th scope="col">Email Address</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {fetching && (
              <tr>
                <td colSpan={10}>
                  <BaseLoader /> <small className="fs-small">Fetching...</small>
                </td>
              </tr>
            )}
            {pendingInvites.map((a, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                {/* <td>{invite.employeeId}</td> */}
                <td>{a.name}</td>
                <td>{a.email}</td>
                {/* <td>{invite.totalCheckIns}</td> */}
                {/* <td>{invite.totalCheckOuts}</td> */}
                {/* <td>{moment(invite.dateJoined).format("YYYY-MM-DD")}</td> */}
                <td style={{ width: 50 }}>
                  <div
                    style={{ width: 50 }}
                    className="d-flex align-items-center justify-content-center"
                  >
                    {loadingItem === a._id ? (
                      <BaseLoader />
                    ) : (
                      <Menu
                        onValue={(value) => {
                          if (value.action === 'resend') {
                            ResendInvitation(a);
                          }
                          if (value.action === 'cancel') {
                            setSelectedEmployee(a);
                          }
                        }}
                        type="data"
                      >
                        <ThreeVerticalDotsIcon />
                      </Menu>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {selectedEmployee && (
          <ConfirmDialogComponent
            onClose={() => {
              setSelectedEmployee(null);
            }}
            confirm={() => {
              CancelInvitation(selectedEmployee);
              setSelectedEmployee(null);
            }}
          />
        )}
      </div>
    );
  }

  const ActiveEmployeeTab = () => {
    return (
      <div className="">
        <table className='table'>
          <thead>
            <tr>
              <th scope="col">S.No.</th>
              <th scope="col">Employee ID</th>
              <th scope="col">Employee Name</th>
              <th scope="col">Email Address</th>
              <th scope="col">Total Check-Ins</th>
              <th scope="col">Total Check-Outs</th>
              <th scope="col">Date Joined</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {fetching && (
              <tr>
                <td colSpan={10}>
                  <BaseLoader /> <small className="fs-small">Fetching...</small>
                </td>
              </tr>
            )}
            {activeEmployees.map((employee, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{employee?.employeeId}</td>
                <td>{`${employee.firstName} ${employee.lastName}`}</td>
                <td>{employee.email}</td>
                <td>
                  {employee.totalCheckIns?employee.totalCheckIns:0}
                </td>
                <td>
                {employee.totalCheckOuts?employee.totalCheckOuts:0}
                </td>
                <td>{moment(employee.createdAt).format("YYYY-MM-DD")}</td>
                <td>
                <Menu
                onValue={(value) => {
                  if (value.action === "delete") {
                    setSelectedEmployee({...employee,action:"delete"});
                    setShowConfirmDialog(true);
                  }
                  if (value.action === "view") {
                    setSelectedEmployee({...employee,action:"view"})
                  }
                  if (value.action === "edit") {
                    setSelectedEmployee({...employee,action:"edit"})
                  }
                }}
                type='employee'
              >
                <ThreeVerticalDotsIcon />
              </Menu>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {(selectedEmployee?.action === "edit" || selectedEmployee?.action === "view") && (
          <EditUserComponent
            loading={updating}
            employeeData={selectedEmployee}
            businessDetails={props.businessDetails!}
            onClose={(status) => {
              if(status)
              {
                emitEvent(CONSTANTS.Events.businessDetails,{})
              }
              setSelectedEmployee(null)
            }}
            onValue={(values) => {
            }}
          />
        )}
        {showConfirmDialog && (
          <ConfirmDialogComponent
          title={`Delete employee?`}
            onClose={() => {
              setShowConfirmDialog(false);
            }}
            data={selectedEmployee!}
            loading={loading}
            confirm={() => {
              DeleteUser(selectedEmployee?._id);
            }}
          />
        )}
      </div>
    );
  }

  return (
    <div className='mt-3'>
      <div className="row">
        <div className="col-6">
          <nav className="nav pl-c">
            <span
              onClick={() => {
                setTab("employee");
                setSearchText('');
              }}
              className={`nav-link active btn p-2 mb-2 ${tab === "employee" ? "fw-bold selected-tab" : "fw-normal"
                }`}
              aria-current="page">
              Employees <span>({props.employees.length})</span>
            </span>
            <span
              onClick={() => {
                setTab("invited");
                setSearchText('');
              }}
              className={`nav-link btn p-2 mb-2 ${tab === "invited" ? "fw-bold selected-tab" : "fw-normal"}`}>
              Invited members  <span>({numberOfPending})</span>
            </span>
          </nav>
        </div>
        <div className="col-6">
          <EmployeeBar
            calenderPosition={'right'}
            onSearch={(d) => {
              setFilterString(d);
            }}
            page="history"
            onAddEmployee={() => {
              setShowAddPersonnel(true);
            }}
            processing={processing}
            onExportPersonnel={() => {
              handleExport();
            }}
            onImportBusiness={() => {
              setShowImportPersonnel(true)
            }}
          />
        </div>
      </div>

      <div>
        {tab === "employee" && <ActiveEmployeeTab />}
        {tab === "invited" && <PendingInvitesTab />}
      </div>
      <Pagination
        onFilterRow={(d) => {
          setPageSize(d);
        }}
        onPage={(d) => {
          setCurrentPage(d);
        }}
      />
      {showAddPersonnel && (
        <AddEmployeeComponent 
        data={props.businessDetails}
        onClose={() =>setShowAddPersonnel(false)}
        />
      )}
      {showImportPersonnel && (
        <ImportPersonnelComponent onClose={() =>
          setShowImportPersonnel(false)}
        />
      )}
    </div>
  );
}
interface BusinessTreepzProps {
  id:string;
  employees:BusinessProps[];
}
const BusinessTreepz = ({id,employees}:BusinessTreepzProps) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [processing, setProcessing] = useState<boolean>(false)
  const [chartCheckInData, setchartCheckInData] = useState<ChartDataProps>({
      data: [],
      labels: []
    }
  )
  const [chartCheckOutData, setchartCheckOutData] = useState<ChartDataProps>({
      data: [],
      labels: []
    }
  )
  const [searching, setSearching] = useState<boolean>(false)
  const [fetching, setFetching] = useState(false);
  const [allEmployeesCount, setAllEmployeesCount] = useState<number>(employees.length);
  const [totalCheckIn, setTotalCheckIn] = useState<number>(0);
  const [totalCheckOut, setTotalCheckOut] = useState<number>(0);
  const [historyList, setHistoryList] = useState<HistoryProps[]>([]);
  const [startDate, setStartDate] = useState<string>(moment().subtract(3, "M").toISOString());
  const [endDate, setEndDate] = useState<string>(moment().toISOString());
  const [pageSize, setPageSize] = useState<number>(50);
  const [searchText, setSearchText] = useState<string>('');

  const allEmployees = async () => {
    setLoading(true);
    // try {
    //   const response = await GetRequest(`business/${_id}`, {});

    //   if (response.status) {
    //     console.log('API to get attendance that i know not of', response)
    //     const businessData: BusinessProps = response.data.business;
    //     if (businessData.employees) {
    //       setAllEmployeesCount(businessData.employees.length);
    //       setTotalEmployees(businessData.employees.length);
    //       console.log('Fetched Employees:', businessData.employees);
    //     }
    //   } else {
    //     console.warn('Failed to fetch business details:', response);
    //     setError('Failed to fetch business details.');
    //   }
    // } catch (error) {
    //   console.error('Error fetching business details:', error);
    //   setError('An error occurred while fetching business details.');
    // } finally {
    //   setLoading(false);
    // }
  };

  const AllChartData = () => {
    setSearching(true)
    GetRequest("admin/attendence/report", {
      startDate: moment(startDate).format("YYYY-MM-DD"),
      endDate: moment(endDate).format("YYYY-MM-DD")
    }, false).then((res) => {
      setSearching(false)
      var selectMonths: string[] = [];
      var countIntervalsCheckIn: number[] = [];
      var countIntervalsCheckOut: number[] = [];
      if (res.status) {
        console.log('API to get attendance that i know not of', res)
        res.data.forEach((a: any, i: number) => {
          const month = moment(a.checkIns[0]).format("MMM");
          selectMonths.push(month);
          countIntervalsCheckIn.push(a.checkIns.length);
          countIntervalsCheckIn.push(100);
          countIntervalsCheckOut.push(a.checkOuts.length);
          countIntervalsCheckOut.push(100);
        })
        setchartCheckInData({
          data: countIntervalsCheckIn,
          labels: selectMonths
        })
        setchartCheckOutData({
          data: countIntervalsCheckOut,
          labels: selectMonths
        })
      } else {
        const month = moment(startDate).format("MMM");
        setchartCheckInData({
          data: [0, 100],
          labels: [month]
        })
        setchartCheckOutData({
          data: [0, 100],
          labels: [month]
        })
      }
    })
  }

  const fetchBusinessTrips = async () => {
    setFetching(true);
      GetRequest(`business/trips/${id}`,{}).then((res)=>{
        if(res.status)
        {
          setHistoryList(res.data.trips);
        }
      })
  };

  const AllCheckInCheckOut = async () => {
    try {
      const checkInResponse = await GetRequest("trip/check-in", {}, false);
      if (checkInResponse.status) {
        setTotalCheckIn(checkInResponse.data?.totalCheckIns || 0);
      }

      const checkOutResponse = await GetRequest("trip/check-out", {}, false);
      if (checkOutResponse.status) {
        setTotalCheckOut(checkOutResponse.data.totalCheckOuts || 0);
      }
    } catch (error) {
      console.error('Error fetching check-in/check-out data:', error);
    }
  };

  const DeleteUser = (id: string) => {
    PostRequest("delete:admin/user", {
      id: id
    }).then((res) => {
      if (res.status) {
        setHistoryList(historyList.filter((a, i) => a.employeeId !== id));
      }
    })
  }

  const handleExport = () => {
    const list = historyList.map((a,i)=>{
      return {
        name:a.rider,
        email:a.email,
        checkInTime:a.checkInTime,
        checkOutTime:a.checkOutTime,
        checkoutType:a.checkoutType,
        date:a.createdAt
      }
    });
    DownloadCSV({ data: list, fileName: "history_list" });
  };

  useEffect(() => {
      fetchBusinessTrips();
      // AllCheckInCheckOut();
      // AllChartData();
      // thisView.current?.addEventListener("mouseleave", () => {
      //   setShowCalendar(false);
      // })
   
  }, []);

  const tabs: TabProp[] = [
    { class: 'light-yellow-card', title: 'Total Employees', amount: allEmployeesCount },
    { class: "gray-card", title: "Total Check-ins", amount: totalCheckIn },
    { class: 'Pale-blue-card', title: "Total Check-outs", amount: totalCheckOut }
  ];

  const thisView = useRef() as RefObject<HTMLDivElement>

  function setShowImportBusiness(arg0: boolean): void {
    throw new Error('Function not implemented.');
  }

  return (
    <div style={{ position: "relative" }}>
      <div className='pt-2' >
        <ChartBoardBusiness
              backgroundColor="white"
              tabs={tabs}
              id={id}
            />
        <div className="row mt-3 fw-bold">
          <div className="col-3">
            <p>Treepz history</p>
          </div>
          <SearchBar
            calenderPosition="right"
            onSearch={(d) => {
              setSearchText(d);
            }}
            processing={processing}
            page="businesses"
            onExportPersonnel={() => {
              handleExport();
            }}
            onImportBusiness={() =>
              setShowImportBusiness(true)
            }
            showFilter={true}
            onFilterValue={({ startDate, endDate }) => {
            }}
             
          />
        </div>

        <table className="table table-responsive">
          <thead>
            <tr>
              <th scope="col">S. No.</th>
              <th scope="col">Employee ID.</th>
              <th scope="col">Employee Name</th>
              <th scope="col">Date</th>
              <th scope="col">Check-In</th>
              <th scope="col">Check-Out</th>
              <th scope="col">Log type</th>
              <th scope='col'></th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={10}>
                  <BaseLoader /> <small className='fs-small'>Fetching...</small>
                </td>
              </tr>
            )}
            {historyList.filter((a,i)=>String(String(a.name).toLowerCase()).includes(String(searchText).toLowerCase()) || String(String(a.email).toLowerCase()).includes(String(searchText).toLowerCase()) || String(String(a.rider).toLowerCase()).includes(String(searchText).toLowerCase()) || String(String(a.companyName).toLowerCase()).includes(String(searchText).toLowerCase())).map((item, i) => (
            <tr key={i}>
              <td>{(i + 1) > 9?(i + 1):""+(i + 1)}</td>
              <td>{item.employeeId}</td>
              <td>{item.name}</td>
              <td>{moment(item.createdAt).format("Do, MMM YYYY")}</td>
              <td>{moment(item.checkInTime).format("hh:mm A")}</td>
              <td>{moment(item.checkOutTime).format("hh:mm A")}</td>
              <td>{item.checkoutType !== "Manual"?<AutomaticStatus />:<ManualStatus />}</td>
              <td style={{ width: 50 }}>
              {/* <Menu
                onValue={(value) => {
                  if (value.action === "delete") {
                    // DeleteUser(item.employeeId)
                  }
                  if (value.action === "view") {
                    // setEmployeeDetails(item)
                  }
                }}
                type='history'
              >
                <ThreeVerticalDotsIcon />
              </Menu> */}
              </td>
            </tr>
          ))} 
          </tbody>
        </table>
      </div>
      <Pagination
        onFilterRow={(size) => setPageSize(size)}
        onPage={() => fetchBusinessTrips()}
      />
    </div>
  );
};

const GetTotalCheckInOfEmployee = (prop:{id:string})=>{
  const [count,setCount] = useState<number>(0);
  useEffect(()=>{
    GetRequest(`business/trips/${prop.id}`,{}).then((res)=>{
      if(res.status)
      {
        // .filter((a,i)=>a.checkOutType === "Completed")
        setCount(res.data.trips.length)
      }
    })
  },[])
  return <div>{count}</div>;
}
const GetTotalCheckOutOfEmployee = (prop:{id:string})=>{
  const [count,setCount] = useState<number>(0);
  useEffect(()=>{
    GetRequest(`business/trips/${prop.id}`,{}).then((res)=>{
      if(res.status)
      {
        setCount(res.data.trips.length)
      }
    })
  },[])
  return <div>{count}</div>;
}

interface ChartBoardBusinessProps {
  tabs: TabProps[];
  backgroundColor?: string;
  onSearch?:()=>void;
  id?:string;
}
interface AllTotalProps {
  totalCheckIns:number;
  totalCheckOuts: number;
}
export const ChartBoardBusiness = (props: ChartBoardBusinessProps) => {
  const [showCalendar, setShowCalendar] = useState<boolean>(false)
  const [trips, setTrips] = useState<HistoryProps[]>([])
  const [allTotal, setAllTotal] = useState<AllTotalProps>({
    totalCheckIns:0,
    totalCheckOuts:0
  })
  const [startDate, setStartDate] = useState<string>(moment().toISOString())
  const [endDate, setEndDate] = useState<string>(moment().subtract(3,"month").toISOString())
  const [searching, setSearch] = useState<boolean>(false);
  const GetTotalCheckInOut = ()=>{
    GetRequest(`business/trips/check-ins-check-outs/${props.id}`,{}).then((res)=>{
      if(res.status && res.data.checkInsAndCheckOuts)
      {
        setAllTotal(res.data.checkInsAndCheckOuts);
      }
    })
  }
  useEffect(()=>{
    GetTotalCheckInOut();
  },[])
  return <div className='row position-relative'>
    <div className="col-3">
            <p className='fw-bold'>Activity Insight</p>
            <div
              // ref={thisView}
              >
              <div
                className='cursor-pointer'
                onClick={() => {
                  setShowCalendar(!showCalendar);
                }}
              >
                <div className='bx'>
                  {searching ? <BaseLoader /> : <CalendarIcon />}
                  <span className='tx' style={{fontSize:12}}>{moment(startDate).format("MMM DD, YYYY")} - {moment(endDate).format("MMM DD, YYYY")}</span>
                  <span className='caret'
                  >
                    <CaretDownIcon />
                  </span> 
                </div>
              </div>
              {showCalendar && <CalendarComponent
                calenderPosition="right"
                onClose={() => {
                  setShowCalendar(false)
                }}
                startDate={moment().subtract(3, "M").format("MM-DD-YYYY")}
                onValue={({ startDate, endDate }) => {
                  setEndDate(endDate)
                  setStartDate(startDate)
                  setShowCalendar(false)
                  // setTimeout(() => {
                  //   AllChartData()
                  // }, 1000)
                }}
                endDate={moment().format("MM-DD-YYYY")}
              />}
            </div>
          </div>
    {props.tabs.map((a:TabProps, i:number) => <div className='col-3 p-1' key={i} >
          <div className={`card dx-card ${a.class} m-0 p-0`} style={{ borderWidth: 0 }}>
              <div className='row ps-3'>
                  <div className='col-12 p-3'>
                      <div className='t1' >{a.title}</div>
                      <div className='t2' >{i === 1?allTotal.totalCheckIns:i === 2?allTotal.totalCheckOuts:a.amount}</div>
                      <div className='d-flex'>
                          <span className='gt'>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L12 4M12 4H6.66667M12 4V9.33333" stroke="#3CC13B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                              </svg>
                              0%
                          </span>
                          <span className='fs-10 ps-2 pt-3'>FROM LAST MONTH</span>
                      </div>
                  </div>

              </div>
          </div>
      </div>)}
      </div>

}

export const AutomaticStatus = ()=>{
  return <svg width="84" height="20" viewBox="0 0 84 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="0.666992" width="83" height="20" rx="10" fill="#007AFF" fill-opacity="0.12"/>
  <rect x="0.916992" y="0.25" width="82.5" height="19.5" rx="9.75" stroke="#007AFF" stroke-opacity="0.04" stroke-width="0.5"/>
  <path opacity="0.5" d="M7.5 11.6665C7.5 10.488 7.5 9.89874 7.86612 9.53262C8.23223 9.1665 8.82149 9.1665 10 9.1665H13.3333C14.5118 9.1665 15.1011 9.1665 15.4672 9.53262C15.8333 9.89874 15.8333 10.488 15.8333 11.6665C15.8333 12.845 15.8333 13.4343 15.4672 13.8004C15.1011 14.1665 14.5118 14.1665 13.3333 14.1665H10C8.82149 14.1665 8.23223 14.1665 7.86612 13.8004C7.5 13.4343 7.5 12.845 7.5 11.6665Z" fill="#007AFF"/>
  <path d="M9.47949 8.3335C9.47949 7.12537 10.4589 6.146 11.667 6.146C12.6859 6.146 13.5427 6.84284 13.7856 7.78639C13.8286 7.95353 13.999 8.05415 14.1661 8.01113C14.3333 7.96811 14.4339 7.79774 14.3909 7.6306C14.0787 6.41762 12.9779 5.521 11.667 5.521C10.1137 5.521 8.85449 6.7802 8.85449 8.3335V9.18958C9.03637 9.176 9.24309 9.17053 9.47949 9.16832V8.3335Z" fill="#007AFF"/>
  <path d="M25.447 14L24.679 12.044H20.767L19.999 14H18.907L22.111 5.84H23.383L26.599 14H25.447ZM22.483 7.628L21.103 11.156H24.343L22.963 7.628L22.723 6.908L22.483 7.628ZM31.9552 11.396V7.628H33.0112V14H31.9552V13.136C31.5232 13.808 30.8512 14.144 30.0232 14.144C28.6912 14.144 27.8992 13.364 27.8992 11.888V7.628H28.9552V11.672C28.9552 12.632 29.3752 13.244 30.3112 13.244C31.3432 13.244 31.9552 12.308 31.9552 11.396ZM35.2401 12.164V8.468H34.3521V7.628H35.2401V6.164H36.2961V7.628H37.7001V8.468H36.2961V12.164C36.2961 12.932 36.5241 13.292 37.4601 13.292H37.6761V14.048C37.5561 14.108 37.2921 14.144 36.9921 14.144C35.8041 14.144 35.2401 13.508 35.2401 12.164ZM41.6974 14.144C39.8734 14.144 38.7814 12.896 38.7814 10.82C38.7814 8.66 39.9094 7.472 41.6974 7.472C43.5214 7.472 44.6134 8.744 44.6134 10.82C44.6134 12.968 43.4854 14.144 41.6974 14.144ZM41.6974 13.232C42.8854 13.232 43.5334 12.38 43.5334 10.82C43.5334 9.272 42.8734 8.384 41.6974 8.384C40.5094 8.384 39.8614 9.248 39.8614 10.82C39.8614 12.356 40.5214 13.232 41.6974 13.232ZM46.3726 14V7.628H47.4286V8.444C47.8366 7.796 48.4726 7.472 49.2526 7.472C50.1286 7.472 50.7646 7.856 51.0646 8.6C51.4846 7.856 52.1806 7.472 53.0326 7.472C54.3286 7.472 55.1086 8.264 55.1086 9.74V14H54.0526V9.956C54.0526 8.996 53.6686 8.372 52.8046 8.372C51.8446 8.372 51.2686 9.32 51.2686 10.232V14H50.2126V9.956C50.2126 8.996 49.8286 8.372 48.9646 8.372C48.0046 8.372 47.4286 9.32 47.4286 10.232V14H46.3726ZM58.1626 9.704H57.1066C57.3106 8.3 58.2346 7.472 59.7946 7.472C61.4986 7.472 62.3266 8.468 62.3266 9.956V12.464C62.3266 13.196 62.3866 13.652 62.5546 14H61.4386C61.3186 13.748 61.2826 13.376 61.2706 12.992C60.7306 13.796 59.8666 14.144 59.0986 14.144C57.7786 14.144 56.8906 13.532 56.8906 12.32C56.8906 11.444 57.3706 10.808 58.3066 10.496C59.1706 10.208 60.0466 10.136 61.2706 10.124V9.98C61.2706 8.948 60.7906 8.384 59.6986 8.384C58.7866 8.384 58.2946 8.888 58.1626 9.704ZM57.9706 12.296C57.9706 12.884 58.4626 13.232 59.2066 13.232C60.3826 13.232 61.2706 12.308 61.2706 11.216V10.916C58.5586 10.94 57.9706 11.516 57.9706 12.296ZM64.6018 12.164V8.468H63.7138V7.628H64.6018V6.164H65.6578V7.628H67.0618V8.468H65.6578V12.164C65.6578 12.932 65.8858 13.292 66.8218 13.292H67.0378V14.048C66.9178 14.108 66.6538 14.144 66.3538 14.144C65.1658 14.144 64.6018 13.508 64.6018 12.164ZM68.4671 6.776V5.36H69.5231V6.776H68.4671ZM68.4671 14V7.628H69.5231V14H68.4671ZM76.8656 9.824H75.8096C75.6416 8.852 74.9936 8.384 74.1536 8.384C72.9776 8.384 72.3536 9.248 72.3536 10.82C72.3536 12.368 73.0136 13.244 74.1896 13.244C75.0416 13.244 75.6536 12.788 75.8576 11.876H76.9136C76.6256 13.46 75.5576 14.144 74.1656 14.144C72.3536 14.144 71.2736 12.884 71.2736 10.82C71.2736 8.66 72.3776 7.472 74.1536 7.472C75.5576 7.472 76.6616 8.264 76.8656 9.824Z" fill="#007AFF"/>
  </svg>
}

export const ManualStatus = ()=>{
return <svg width="68" height="20" viewBox="0 0 68 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.666992" width="67" height="20" rx="10" fill="#00C7BE" fill-opacity="0.12"/>
<rect x="0.916992" y="0.25" width="66.5" height="19.5" rx="9.75" stroke="#00C7BE" stroke-opacity="0.04" stroke-width="0.5"/>
<g opacity="0.5">
<path d="M11.0638 10.6031C10.8872 10.4265 10.6675 10.3545 10.4242 10.3218C10.1937 10.2908 9.90329 10.2908 9.55504 10.2909L9.09465 10.2909C8.8527 10.2909 8.65077 10.2909 8.48676 10.3064C8.31531 10.3227 8.15552 10.3581 8.00897 10.4479C7.86554 10.5358 7.74496 10.6564 7.65707 10.7998C7.56726 10.9464 7.53189 11.1062 7.51559 11.2776C7.49999 11.4416 7.5 11.6436 7.5 11.8855V11.914C7.5 12.2822 7.49999 12.5792 7.52272 12.8183C7.54617 13.0648 7.59582 13.2796 7.71419 13.4728C7.83404 13.6684 7.99847 13.8328 8.19404 13.9526C8.3872 14.071 8.60201 14.1207 8.84855 14.1441C9.08762 14.1668 9.3846 14.1668 9.75284 14.1668H9.78128C10.0232 14.1668 10.2252 14.1668 10.3892 14.1512C10.5607 14.1349 10.7204 14.0996 10.867 14.0098C11.0104 13.9219 11.131 13.8013 11.2189 13.6579C11.3087 13.5113 11.3441 13.3515 11.3604 13.1801C11.376 13.0161 11.376 12.8141 11.376 12.5721L11.376 12.1118C11.376 11.7636 11.376 11.4731 11.345 11.2426C11.3123 10.9993 11.2403 10.7796 11.0638 10.6031Z" fill="#00C7BE"/>
<path d="M10.3892 5.84908C10.5607 5.86538 10.7204 5.90076 10.867 5.99057C11.0104 6.07846 11.131 6.19904 11.2189 6.34246C11.3087 6.48902 11.3441 6.6488 11.3604 6.82026C11.376 6.98426 11.376 7.18624 11.376 7.42819L11.376 7.88855C11.376 8.23679 11.376 8.52718 11.345 8.75771C11.3123 9.00104 11.2403 9.22073 11.0638 9.39727C10.8872 9.57381 10.6675 9.64578 10.4242 9.67849C10.1937 9.70949 9.90328 9.70948 9.55504 9.70947L9.09463 9.70947C8.85268 9.70947 8.65076 9.70948 8.48676 9.69388C8.31531 9.67758 8.15552 9.64221 8.00897 9.5524C7.86554 9.46451 7.74496 9.34392 7.65707 9.2005C7.56726 9.05394 7.53189 8.89416 7.51559 8.7227C7.49999 8.55869 7.5 8.35674 7.5 8.11477V8.08633C7.5 7.71809 7.49999 7.42112 7.52272 7.18205C7.54617 6.9355 7.59582 6.7207 7.71419 6.52754C7.83404 6.33196 7.99847 6.16753 8.19404 6.04768C8.3872 5.92931 8.60201 5.87966 8.84855 5.85622C9.08762 5.83349 9.38461 5.83349 9.75285 5.8335H9.78129C10.0233 5.83349 10.2252 5.83349 10.3892 5.84908Z" fill="#00C7BE"/>
<path d="M13.5805 5.8335H13.5521C13.3101 5.83349 13.1081 5.83349 12.9441 5.84908C12.7727 5.86538 12.6129 5.90076 12.4663 5.99057C12.3229 6.07846 12.2023 6.19904 12.1144 6.34246C12.0246 6.48902 11.9893 6.6488 11.9729 6.82026C11.9574 6.98427 11.9574 7.18622 11.9574 7.42818L11.9574 7.88854C11.9574 8.23678 11.9573 8.52718 11.9883 8.75771C12.0211 9.00104 12.093 9.22073 12.2696 9.39727C12.4461 9.57381 12.6658 9.64578 12.9091 9.67849C13.1396 9.70949 13.43 9.70948 13.7783 9.70947L14.2387 9.70947C14.4806 9.70947 14.6826 9.70948 14.8466 9.69388C15.018 9.67758 15.1778 9.64221 15.3244 9.5524C15.4678 9.46451 15.5884 9.34392 15.6763 9.2005C15.7661 9.05394 15.8014 8.89416 15.8177 8.7227C15.8333 8.5587 15.8333 8.35677 15.8333 8.11482V8.08634C15.8333 7.7181 15.8333 7.42112 15.8106 7.18205C15.7872 6.9355 15.7375 6.7207 15.6191 6.52754C15.4993 6.33196 15.3349 6.16753 15.1393 6.04768C14.9461 5.92931 14.7313 5.87966 14.4848 5.85622C14.2457 5.83349 13.9487 5.83349 13.5805 5.8335Z" fill="#00C7BE"/>
</g>
<path opacity="0.4" d="M12.5394 13.8762C12.5394 14.0367 12.4093 14.1669 12.2487 14.1669C12.0882 14.1669 11.958 14.0367 11.958 13.8762V12.7134H12.5394V13.8762Z" fill="#00C7BE"/>
<path opacity="0.5" d="M15.5427 10.2905C15.3821 10.2905 15.252 10.4207 15.252 10.5812V11.9378H15.8333V10.5812C15.8333 10.4207 15.7032 10.2905 15.5427 10.2905Z" fill="#00C7BE"/>
<path d="M13.3657 11.9237C13.334 12.0003 13.334 12.0974 13.334 12.2915C13.334 12.4856 13.334 12.5827 13.3657 12.6593C13.408 12.7614 13.4891 12.8425 13.5912 12.8848C13.6678 12.9165 13.7648 12.9165 13.959 12.9165C14.1531 12.9165 14.2502 12.9165 14.3268 12.8848C14.4289 12.8425 14.51 12.7614 14.5523 12.6593C14.584 12.5827 14.584 12.4856 14.584 12.2915C14.584 12.0974 14.584 12.0003 14.5523 11.9237C14.51 11.8216 14.4289 11.7405 14.3268 11.6982C14.2502 11.6665 14.1531 11.6665 13.959 11.6665C13.7648 11.6665 13.6678 11.6665 13.5912 11.6982C13.4891 11.7405 13.408 11.8216 13.3657 11.9237Z" fill="#00C7BE"/>
<path opacity="0.7" d="M15.8332 12.7232V12.7134H15.2518C15.2518 12.898 15.2516 13.0218 15.2451 13.1177C15.2387 13.211 15.2273 13.2565 15.2149 13.2864C15.1657 13.4051 15.0714 13.4994 14.9527 13.5486C14.9228 13.561 14.8774 13.5724 14.784 13.5788C14.6881 13.5853 14.5643 13.5855 14.3797 13.5855H13.6045V14.1669H14.3895C14.5617 14.1669 14.7056 14.1669 14.8236 14.1588C14.9465 14.1504 15.0626 14.1324 15.1752 14.0857C15.4364 13.9775 15.6439 13.77 15.752 13.5089C15.7987 13.3963 15.8167 13.2802 15.8251 13.1573C15.8332 13.0393 15.8332 12.8954 15.8332 12.7232Z" fill="#00C7BE"/>
<path opacity="0.6" d="M11.957 11.923V11.9378H12.5384C12.5384 11.6596 12.5388 11.4728 12.5533 11.3304C12.5673 11.1928 12.592 11.1293 12.6201 11.0872C12.6554 11.0343 12.7008 10.9889 12.7538 10.9536C12.7958 10.9255 12.8593 10.9008 12.9969 10.8868C13.1393 10.8723 13.3261 10.8719 13.6043 10.8719H14.3795V10.2905H13.5895C13.3299 10.2905 13.1134 10.2905 12.938 10.3084C12.7545 10.327 12.5842 10.3676 12.4307 10.4702C12.3144 10.5479 12.2144 10.6479 12.1367 10.7642C12.0341 10.9177 11.9935 11.088 11.9749 11.2715C11.957 11.4469 11.957 11.6634 11.957 11.923Z" fill="#00C7BE"/>
<path d="M8.96192 12.7875C9.0529 12.8521 9.18175 12.8521 9.43945 12.8521C9.69716 12.8521 9.82601 12.8521 9.91699 12.7875C9.94909 12.7647 9.97712 12.7367 9.9999 12.7046C10.0645 12.6136 10.0645 12.4848 10.0645 12.2271C10.0645 11.9693 10.0645 11.8405 9.9999 11.7495C9.97712 11.7174 9.94909 11.6894 9.91699 11.6666C9.82601 11.6021 9.69715 11.6021 9.43945 11.6021C9.18175 11.6021 9.0529 11.6021 8.96192 11.6666C8.92982 11.6894 8.90179 11.7174 8.87901 11.7495C8.81445 11.8405 8.81445 11.9693 8.81445 12.2271C8.81445 12.4848 8.81445 12.6136 8.87901 12.7046C8.90179 12.7367 8.92982 12.7647 8.96192 12.7875Z" fill="#00C7BE"/>
<path d="M9.43945 8.39795C9.18175 8.39795 9.0529 8.39795 8.96192 8.3334C8.92982 8.31062 8.90179 8.28259 8.87901 8.25048C8.81445 8.1595 8.81445 8.03065 8.81445 7.77295C8.81445 7.51525 8.81445 7.38639 8.87901 7.29541C8.90179 7.26331 8.92982 7.23528 8.96192 7.2125C9.0529 7.14795 9.18175 7.14795 9.43945 7.14795C9.69716 7.14795 9.82601 7.14795 9.91699 7.2125C9.94909 7.23528 9.97712 7.26331 9.9999 7.29541C10.0645 7.38639 10.0645 7.51525 10.0645 7.77295C10.0645 8.03065 10.0645 8.1595 9.9999 8.25048C9.97712 8.28259 9.94909 8.31062 9.91699 8.3334C9.82601 8.39795 9.69716 8.39795 9.43945 8.39795Z" fill="#00C7BE"/>
<path d="M13.417 8.33346C13.508 8.39801 13.6368 8.39801 13.8945 8.39801C14.1522 8.39801 14.2811 8.39801 14.3721 8.33346C14.4042 8.31068 14.4322 8.28265 14.455 8.25054C14.5195 8.15956 14.5195 8.03071 14.5195 7.77301C14.5195 7.51531 14.5195 7.38645 14.455 7.29547C14.4322 7.26337 14.4042 7.23534 14.3721 7.21256C14.2811 7.14801 14.1522 7.14801 13.8945 7.14801C13.6368 7.14801 13.508 7.14801 13.417 7.21256C13.3849 7.23534 13.3569 7.26337 13.3341 7.29547C13.2695 7.38645 13.2695 7.51532 13.2695 7.77302C13.2695 8.03071 13.2695 8.15957 13.3341 8.25054C13.3569 8.28265 13.3849 8.31068 13.417 8.33346Z" fill="#00C7BE"/>
<path d="M19.603 14V5.84H21.127L23.635 11.828L23.875 12.56L24.127 11.828L26.623 5.84H28.099V14H26.995V7.172L26.419 8.78L24.235 14H23.455L21.271 8.768L20.707 7.208V14H19.603ZM31.2501 9.704H30.1941C30.3981 8.3 31.3221 7.472 32.8821 7.472C34.5861 7.472 35.4141 8.468 35.4141 9.956V12.464C35.4141 13.196 35.4741 13.652 35.6421 14H34.5261C34.4061 13.748 34.3701 13.376 34.3581 12.992C33.8181 13.796 32.9541 14.144 32.1861 14.144C30.8661 14.144 29.9781 13.532 29.9781 12.32C29.9781 11.444 30.4581 10.808 31.3941 10.496C32.2581 10.208 33.1341 10.136 34.3581 10.124V9.98C34.3581 8.948 33.8781 8.384 32.7861 8.384C31.8741 8.384 31.3821 8.888 31.2501 9.704ZM31.0581 12.296C31.0581 12.884 31.5501 13.232 32.2941 13.232C33.4701 13.232 34.3581 12.308 34.3581 11.216V10.916C31.6461 10.94 31.0581 11.516 31.0581 12.296ZM37.5453 14V7.628H38.6013V8.492C39.0333 7.82 39.7293 7.472 40.5693 7.472C41.9253 7.472 42.7293 8.264 42.7293 9.74V14H41.6733V9.956C41.6733 8.996 41.2413 8.372 40.2813 8.372C39.2253 8.372 38.6013 9.32 38.6013 10.232V14H37.5453ZM48.8685 11.396V7.628H49.9245V14H48.8685V13.136C48.4365 13.808 47.7645 14.144 46.9365 14.144C45.6045 14.144 44.8125 13.364 44.8125 11.888V7.628H45.8685V11.672C45.8685 12.632 46.2885 13.244 47.2245 13.244C48.2565 13.244 48.8685 12.308 48.8685 11.396ZM52.9813 9.704H51.9253C52.1293 8.3 53.0533 7.472 54.6133 7.472C56.3173 7.472 57.1453 8.468 57.1453 9.956V12.464C57.1453 13.196 57.2053 13.652 57.3733 14H56.2573C56.1373 13.748 56.1013 13.376 56.0893 12.992C55.5493 13.796 54.6853 14.144 53.9173 14.144C52.5973 14.144 51.7093 13.532 51.7093 12.32C51.7093 11.444 52.1893 10.808 53.1253 10.496C53.9893 10.208 54.8653 10.136 56.0893 10.124V9.98C56.0893 8.948 55.6093 8.384 54.5173 8.384C53.6053 8.384 53.1133 8.888 52.9813 9.704ZM52.7893 12.296C52.7893 12.884 53.2813 13.232 54.0253 13.232C55.2013 13.232 56.0893 12.308 56.0893 11.216V10.916C53.3773 10.94 52.7893 11.516 52.7893 12.296ZM59.2765 14V5.36H60.3325V14H59.2765Z" fill="#00C7BE"/>
</svg>

}